"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import { workScopeStatusOptions } from "../../constants/options"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import WorkScopeStatusSelect from "../work-scope-status-select"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const BASE_FIELD_NAME = "home.blockWallInfo"

function HomeBlockWallForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillBlockWallRepairOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillBlockWallRepairOn` })
    
    // Watch status field and claimed by field
    const blockWallRepair = useWatch({ control, name: `${BASE_FIELD_NAME}.blockWallRepair` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillBlockWallRepair = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillBlockWallRepair` })
    const goodwillBlockWallRepairClaimedBy = useWatch({
        control,
        name: `${BASE_FIELD_NAME}.goodwillBlockWallRepairClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: blockWallRepair,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillBlockWallRepair,
        claimedBy: goodwillBlockWallRepairClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillBlockWallRepairClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillBlockWallRepairOn,
    })

    return (
        <HomeDetailsWrapperAccordion 
            heading="Block Wall"
            wrapperClassName="xl:grid-cols-2"
        >
            <WorkScopeStatusSelect workScopeSlug="block-wall"
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Block Wall" toggleName={`${BASE_FIELD_NAME}.goodwillBlockWallRepairOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.blockWallRepair`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillBlockWallRepairOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Block Wall Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillBlockWallRepair`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Block Wall Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillBlockWallRepairClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Add any other detail you can about the Block Wall needs",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={4}
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeBlockWallForm

